import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { WarningOctagon } from "@phosphor-icons/react";
import api from "@/lib/api";
import { noBuyerChanged } from "@/components/layout/useNoBuyerCount";

const when = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

// Company-page leads in the last 7 days that reached no buyer.
export function NoBuyerCard() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/traffic-access/no-buyer").then((r) => setData(r.data)).catch(() => setData(false));
  useEffect(() => { load(); }, []);
  const seen = async () => {
    try {
      await api.post("/admin/traffic-access/no-buyer/seen");
      noBuyerChanged();
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't update"); }
  };
  if (!data) return null;
  if (!data.leads.length) {
    return <div className="mb-5 border-2 border-emerald-700 bg-emerald-50 px-3 py-2 text-xs font-bold text-emerald-900" data-testid="no-buyer-clear">Every company-page lead in the last 7 days reached a buyer.</div>;
  }
  return (
    <section className="mb-5 border-2 border-red-700 bg-white" data-testid="no-buyer-card">
      <div className="flex flex-wrap items-center gap-2 border-b-2 border-red-700 bg-red-50 px-3 py-2">
        <WarningOctagon size={18} weight="fill" className="text-red-700" />
        <div className="mr-auto text-sm font-bold text-red-900">Leads no buyer took — last 7 days ({data.leads.length})</div>
        {data.unseen > 0 && (
          <button type="button" onClick={seen} data-testid="no-buyer-seen"
                  className="border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest transition-colors duration-100 hover:bg-black hover:text-white">
            Mark {data.unseen} as seen
          </button>
        )}
      </div>
      <p className="px-3 pt-2 text-xs text-zinc-600">These went to your other delivery rules, then the marketplace. Use <b>Try a lead</b> below to see which buyer would cover them.</p>
      <ul className="divide-y divide-zinc-200 text-xs" data-testid="no-buyer-list">
        {data.leads.slice(0, 25).map((l) => (
          <li key={l.id} className={`flex flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2 ${l.seen ? "" : "bg-red-50/50"}`} data-testid={`no-buyer-${l.id}`}>
            <Link to={`/leads/${l.id}`} className="font-bold underline">{l.name || "Lead"}</Link>
            <span>{l.state} · {l.case_type || "—"} · {l.page || "—"}</span>
            <span className="text-red-800">{l.reason}</span>
            {l.is_test && <span className="bg-zinc-200 px-1 text-[9px] uppercase tracking-widest">Test</span>}
            <span className="ml-auto text-zinc-500">{when(l.created_at)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
